import Request from '@/plugins/request'

export function getGoodsCategories(params) {
  return Request.get('goods-categories', { params })
}

export function createGoodsCategory() {
  return Request.get(`goods-categories/create`)
}

export function storeGoodsCategory(data) {
  return Request.post('goods-categories', data)
}

export function updateGoodsCategory(id, data) {
  return Request.put(`goods-categories/${id}`, data)
}

export function editGoodsCategory(id) {
  return Request.get(`goods-categories/${id}/edit`)
}

export function destroyGoodsCategory(id) {
  return Request.delete(`goods-categories/${id}`)
}

export function updateGoodsCategories(data) {
  return Request.put('goods-categories', data)
}
